var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 438.907 438.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.323 99.837V399.2c0 17.312-14.035 31.347-31.347 31.347H90.931c-17.312 0-31.347-14.035-31.347-31.347V99.837c0-17.312 14.034-31.347 31.347-31.347h51.2v36.571h154.122V68.49h51.722c17.313 0 31.348 14.035 31.348 31.347z",
    fill: "#d4e1f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296.253 68.49v36.571H142.131V39.756h38.139a39.71 39.71 0 0 1 38.661-31.347c18.721-.129 34.917 13.004 38.661 31.347h38.661V68.49z",
    fill: "#00ceb4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#083863"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.976 57.519H308.27V39.756c0-5.747-6.269-8.359-12.016-8.359H265.43C258.539 11.838 239.648-.898 218.932.05c-20.668-.777-39.467 11.896-46.498 31.347h-30.302c-5.747 0-11.494 2.612-11.494 8.359v17.763H90.931c-23.53.251-42.78 18.813-43.886 42.318V399.2c0 22.988 20.898 39.706 43.886 39.706h257.045c22.988 0 43.886-16.718 43.886-39.706V99.837c-1.107-23.505-20.356-42.067-43.886-42.318zm-196.441-5.225h28.735c5.097-.437 9.215-4.339 9.927-9.404 3.094-13.474 14.915-23.146 28.735-23.51a29.78 29.78 0 0 1 28.212 23.51c.937 5.148 5.232 9.013 10.449 9.404h29.78V94.09H151.535V52.294zm219.429 346.907c0 11.494-11.494 18.808-22.988 18.808H90.931c-11.494 0-22.988-7.314-22.988-18.808V99.837c1.066-11.964 10.978-21.201 22.988-21.42h39.706v26.645c.552 5.854 5.622 10.233 11.494 9.927h154.122c5.98.327 11.209-3.992 12.016-9.927V78.417h39.706c12.009.22 21.922 9.456 22.988 21.42v299.364z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -83.592
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    y: -83.591
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: 83.592
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    y: 83.592
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M131.159 290.009c-2.782.089-5.46-1.059-7.314-3.135l-21.42-21.943c-4.047-4.24-4.047-10.911 0-15.151a10.45 10.45 0 0 1 14.629.522l14.106 14.629 33.437-31.869a10.45 10.45 0 0 1 14.629.522 9.93 9.93 0 0 1 .603 14.025 9.8 9.8 0 0 1-.603.603l-40.751 38.661a10.45 10.45 0 0 1-7.316 3.136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M329.168 276.947H209.004a10.45 10.45 0 0 1-10.449-10.449 10.45 10.45 0 0 1 10.449-10.449h120.163a10.45 10.45 0 0 1 10.449 10.449 10.45 10.45 0 0 1-10.448 10.449z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecifications);
export default __webpack_public_path__ + "static/media/specifications.6d67d79550f0ed97a58e16e8cb9c0b41.svg";
export { ForwardRef as ReactComponent };